import { render } from "./NavbarFront.vue?vue&type=template&id=0b39d5c4"
import script from "./NavbarFront.vue?vue&type=script&lang=js"
export * from "./NavbarFront.vue?vue&type=script&lang=js"

import "./NavbarFront.vue?vue&type=style&index=0&id=0b39d5c4&lang=scss"

import exportComponent from "../../../../../SINTEZ/store/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__